import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { CurrentPContext, MasterContext, MobiOrNotContext } from "../ContextApi/context";

import '../Fonts.css';
import '../Style.css';
import '../MySetStyle.css';

import '../DesktopStyle.scss';
import '../MobileMe.scss';


import masterUtil from "../_Utils/utilsMaster";
import ConnUrls from "../Connections/ConnectURL";
import '../animate.css';



const MasterHeadComp = () => {

  const [master, setMaster] = useContext(MasterContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const container = document.getElementById('MainBody');

    if (container) {
      // Remove existing styles
      container.classList.remove('desktop-me-style', 'mobile-me-style');

      // Add the appropriate style based on mobiOrNot
      container.classList.add(mobiOrNot ? 'mobile-me-style' : 'desktop-me-style');
    }
  }, [mobiOrNot]);

  useEffect(() => {
    if (master == null) {
      setThemast();
    }
    setLoading(false)
  }, [])

  useEffect(() => {

  }, [currentPage])


  // const canonicalUrl = document.querySelector("link[rel='canonical']").getAttribute("href");

  const setThemast = async () => {
    let mast = await masterUtil.getMaster();

    setMaster(mast);

  }

  // פונקציה לחישוב תמונה דינמית לפי סוג העמוד
  const getOgImage = () => {
    // מסעדה
    if (currentPage?.buissMainImg) {
      return `${ConnUrls.servMediasUrl}${currentPage.buissMainImg}`;
    }
    // קטגוריה
    if (currentPage?.catImage) {
      return `${ConnUrls.servMediasUrl}${currentPage.catImage}`;
    }
    // דף יחיד
    if (currentPage?.mainImage) {
      return `${ConnUrls.servMediasUrl}${currentPage.mainImage}`;
    }
    // ברירת מחדל - לוגו האתר
    return `${ConnUrls.servMediasUrl}${master?.webSiteLogo || ''}`;
  }

  return (
    <>
      {loading ? "" :
        <Helmet
          title={currentPage.pageName || master?.mainTitle || "אשדוד בתפריט"}
          meta={[
            // Basic Meta Tags
            {
              name: "description",
              content: currentPage.sEOdescription || master?.mainTitle || ""
            },
            {
              name: "keywords",
              content: currentPage.sEOkeywords || master?.mainTitle || ""
            },
            
            // Open Graph Tags
            { property: "og:type", content: "website" },
            { property: "og:site_name", content: "אשדוד בתפריט" },
            { property: "og:title", content: currentPage.pageName || master?.mainTitle || "אשדוד בתפריט" },
            { property: "og:description", content: currentPage.sEOdescription || master?.mainTitle || "" },
            { property: "og:image", content: getOgImage() },
            { property: "og:locale", content: "he_IL" },
            
            // Twitter Cards
            { name: "twitter:card", content: "summary_large_image" },
            { name: "twitter:title", content: currentPage.pageName || master?.mainTitle || "אשדוד בתפריט" },
            { name: "twitter:description", content: currentPage.sEOdescription || master?.mainTitle || "" },
            { name: "twitter:image", content: getOgImage() }

          ]}

        >
        </Helmet>




      }
    </>
  );
}

export default MasterHeadComp;
